import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "category-media"
}
const _hoisted_2 = ["src", "alt"]

import { Ref, computed, onMounted, ref } from 'vue';
import { deviceWidths } from '../../constants';
import useContext from '@/composables/useContext';

export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryMedia',
  setup(__props) {

const { page, toLitiumMediaUrl } = useContext();

const hasBlocks = computed(() => {
  return page.value?.blocks && Object.keys(page.value.blocks).length !== 0;
});

let isMobile: Ref<null | boolean> = ref(null);

const imageUrl = computed(() => {
  if (isMobile?.value == null) {
    return '';
  }

  if (isMobile?.value) {
    const mobileImage = page.value?.fields?.MobileImage;
    if (mobileImage?.id) {
      return toLitiumMediaUrl(mobileImage.id, {
        maxWidth: deviceWidths.phoneMaxWidth
      });
    }
  }

  if (
    !page.value?.fields?.Image?.id &&
    !page.value?.dataJson?.dataJson?.category?.imageId
  ) {
    return '';
  }

  return toLitiumMediaUrl(
    page.value.fields?.Image?.id || page.value?.dataJson?.dataJson?.category?.imageId,
    {
      maxWidth: 1440
    }
  );
});

onMounted(() => {
  isMobile.value =
    typeof window !== 'undefined' &&
    window.innerWidth < deviceWidths.phoneMaxWidth;
  window.addEventListener('resize', () => {
    if (typeof window !== 'undefined') {
      const isMobileScreenSize = window.innerWidth < deviceWidths.phoneMaxWidth;
      if (isMobileScreenSize !== isMobile?.value) {
        isMobile.value = isMobileScreenSize;
      }
    }
  });
});

const imageAlt = computed(() => {
  return page.value?.fields?.Image?.filename || '';
});

const isMobileImage = computed(
  () => isMobile?.value && page.value?.fields?.MobileImage?.id
);

return (_ctx: any,_cache: any) => {
  return (imageUrl.value && !hasBlocks.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: imageUrl.value,
          alt: imageAlt.value,
          class: _normalizeClass([{ 'category-media__mobile-image': isMobileImage.value }, "category-media__image"])
        }, null, 10, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})